export default __webpack_public_path__ + "victory_coins_mobile-eafcf15dd855b97d5ce53a41aa283dae.png";